import { Component, OnInit } from '@angular/core';

import { Role } from '../../auth/models/user';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})
export class SideNavComponent implements OnInit {

  Role = Role;

  constructor() { }

  ngOnInit(): void {
  }

}
